// Shared by AiAddContextModal's Search and Browse tabs, and by MatterAiChat's
// added-context chips/citations — keeps the "add to context" item contract
// ({ itemType, id, title, ... }) consistent across all three.

export const contextItemKey = (item) => `${item.itemType}:${item.id}`;

export const PREVIEWABLE_TYPES = new Set([
	"Document",
	"Email",
	"Matter Note",
	"Matter",
]);

// Case-insensitive "does any of these fields contain this text" check, used
// by both tiers of Browse's client-side filter.
export const filterMatches = (text, ...fields) =>
	fields.some((f) => (f || "").toString().toLowerCase().includes(text));

const CLIENT_NAME_MAX_LENGTH = 60;

// A Matter row's client name has no length limit server-side, but the row
// itself does — cap it so one long name can't blow out the row's layout in
// contexts that don't otherwise clip it with CSS (e.g. ResultRow's
// subtitle line, which wraps instead of ellipsizing).
export const truncateClientName = (name) =>
	name && name.length > CLIENT_NAME_MAX_LENGTH
		? `${name.slice(0, CLIENT_NAME_MAX_LENGTH)}…`
		: name;
